import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {
    type OrganizationalUnitTemplateAdditionalColumn,
    organizationalUnitTemplateAdditionalColumnsZodValidator,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/organizationalUnitsWorkspaceCapability/domain/OrganizationalUnitTemplateAdditionalColumns";

export type OrganizationalUnitTemplate = {
    additionalColumns: Array<OrganizationalUnitTemplateAdditionalColumn>;
    // TODO: Type this more tightly
    configuration: Record<string, unknown>;
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    description: string | null;
    displayName: string;
    id: Uuid;
    instanceDisplayNameTemplate: string;
    parentId: Uuid | null;
    status: OrganizationalUnitTemplateStatus;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
    workspaceId: Uuid;
};

export enum OrganizationalUnitTemplateStatus {
    active = "b335555a-0e77-43de-b19e-770adc38bc5e",
    archived = "0e3858b9-cebc-4f60-b613-ce79c79c12a1",
    deleted = "e7a6313f-657e-4fef-92b5-b09b1234fa3a",
};

export const organizationalUnitTemplateValidator: zod.ZodType<OrganizationalUnitTemplate> = zod.object({
    additionalColumns: organizationalUnitTemplateAdditionalColumnsZodValidator.array(),
    configuration: zod.record(zod.string(), zod.unknown()),
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    description: zod.string().nullable(),
    displayName: zod.string(),
    id: uuidZodValidator,
    instanceDisplayNameTemplate: zod.string(),
    parentId: uuidZodValidator.nullable(),
    status: zod.enum(OrganizationalUnitTemplateStatus),
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    workspaceId: uuidZodValidator,
});
